import http from '@util/http';
import { finance } from '@api/req';

/**
 * 付款
 */
export async function queryPaymentList(params) {
  return http.get(finance.GET_PAYMENT_LIST, params);
}

export async function queryPaymentMyList(params) {
  return http.get(finance.GET_PAYMENT_MY, params);
}

export async function queryMyPaymentCheckList(params) {
  return http.get(finance.GET_PAYMENT_CHECK, params);
}

export async function queryPaymentOrgStatic(params) {
  return http.get(finance.GET_PAYMENT_STATIC_ORG, params);
}

export async function queryPaymentIncubatorStatic(params) {
  return http.get(finance.GET_PAYMENT_STATIC_INCUBATOR, params);
}

export async function queryPaymentOrgRecord(params) {
  return http.get(finance.GET_PAYMENT_RECORD_ORG, params);
}

export async function queryPaymentInfo(params) {
  return http.get(finance.GET_PAYMENT_INFO, params);
}

export async function querySavePayment(params) {
  return http.post(finance.PAYMENT_SAVE, params);
}

export async function queryDeletePayment(params) {
  return http.get(finance.PAYMENT_DELETE, params);
}

export async function queryNextPayment(params) {
  return http.get(finance.PAYMENT_NEXT, params);
}

export async function queryReturnPayment(params) {
  return http.post(finance.PAYMENT_RETURN, params);
}

export async function queryCallbackPayment(params) {
  return http.get(finance.PAYMENT_CALLBACK, params);
}

export async function queryPaymentWorkflow(params) {
  return http.get(finance.PAYMENT_WORKFLOW, params);
}

export async function queryPaymentIncomepart(params) {
  return http.get(finance.PAYMENT_INCOMEPART, params);
}



// WEBPACK FOOTER //
// ./src/api/finance/payment.js